import { TableLargePlusIcon } from './TableLargePlusIcon';

/**
 * author: Michael Irigoyen
 * id 3C206937-03CF-4690-B022-30099AEAE0F3
 * name table-large-plus
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-large-plus.svg
 * tags
 * - Text / Content / Format 
 * - Geographic Information System 
 */
export const TableLargeAddIcon = TableLargePlusIcon;
export default TableLargeAddIcon